import { useQuery } from '@tanstack/react-query'
import { ResponseApiError } from '../../../models/axios-error'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { UseQueryOptionsWithoutQueryKey } from '../../../react-query-config'
import { AggregationLevel, Channel } from '../home.model'

export interface UseApiGetProductivityTargetRequest {
  channel: Channel
  aggregation: AggregationLevel
  storeId: number
  teamId: number | null
}

export interface TargetProductivity {
  value: number | null
}

const getTargetProductivity = async (config: AxiosRequestConfig, enabled: boolean): Promise<TargetProductivity> => {
  if (!enabled) {
    return {
      value: undefined
    }
  }
  const axiosPromise: AxiosResponse<TargetProductivity> = await axios(config)
  return {
    value: axiosPromise.data?.value
  }
}

export const useApiGetTargetProductivity = (
  args: UseApiGetProductivityTargetRequest,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<TargetProductivity>
) => {
  const { storeId, teamId, channel, aggregation } = args
  const teamParam = aggregation === 'TEAM' && teamId !== null ? `&teamId=${teamId}` : ''
  const url = `/instore-target-productivity?aggregation=${aggregation}&channel=${channel}&storeId=${storeId}${teamParam}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<TargetProductivity, ResponseApiError>({
    queryKey: ['get-target-productivity', aggregation, channel, storeId, teamId],
    queryFn: () => getTargetProductivity(config, enabled),
    enabled,
    ...options
  })
}
